import { QuestionBase } from './question-base';

/*

Sample:

    new SwitchQuestion({
      key: 'enabled',
      class: 'col s2 center margin-top',
      switchOffLabel: 'nouns.no',
      switchOnLabel: 'nouns.yes',
      value: user ? user.enabled : true,
      eventHandlers: {
        change: ev => console.log(ev.target.checked, session)
      },
    });

*/
export class SwitchQuestion extends QuestionBase<boolean> {
  controlType = 'switch';
  secondary: boolean;
  switchOffLabel: string; // TODO delete this
  switchOnLabel: string; // TODO delete this
  switchClass: string; // TODO delete this

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
    this.secondary = !!options['secondary'];
    this.switchOffLabel = options['switchOffLabel'] || 'nouns.no';
    this.switchOnLabel = options['switchOnLabel'] || 'nouns.yes';
    this.switchClass = options['switchClass'] || '';
  }
}
